import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const companySetting = {

    namespaced: true,

    state:
    {
        ...baseStates,

        partCategories: [],
        partCategoriesLoading: false,
        partCategoryLoading: false,

        paymentMethods: [],
        paymentMethodsLoading: false,
        paymentMethodLoading: false,
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,

        partCategories: state => state.partCategories,

        paymentMethods: state => state.paymentMethods,
    },
};
